module.exports = __webpack_public_path__ + "media/images/icon__close--rb-dark-gray-2710487526f4e15a3096c70670d424b4.png";